import "@capacitor/core";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { FirebaseCrashlytics, Device, App } from "./plugins";
import { catchErrorWithStack, initCrashlytics } from "./crashlytics";
import store from "./store";
import config, { IS_WEB } from "./config";
import { initializeAds } from "./admob/setup";
import { initAnalytics, logEvent } from "./analytics";
import { incrementLives } from "./lives";
import { showSuccessSnackbar } from "./snackbar";
import { initFirebase } from "./firebase";
import { setCurrentNetworkStatus } from "./network";
import { addDocumentSnapshotListeners } from "./snapshotListeners";
import { fetchStore, fetchProfile } from "./auth.js";
import { setProfileInfoToEls } from "./profileEditor.js";
import { getAllTranslations } from "./translate";
import { yieldWithPriority } from "./promise.js";

if (IS_WEB) defineCustomElements(window);

async function onLoad() {
  if (IS_WEB) onDeviceReady();
  else document.addEventListener("deviceready", onDeviceReady);
}

async function onDeviceReady() {
  await initFirebase();
  await setCurrentNetworkStatus();
  await config.initialize();
  await store.initialize();
  fetchData();
  getAllTranslations();
  await initCrashlytics(FirebaseCrashlytics, Device, App);
  await initAnalytics();
  await addDocumentSnapshotListeners();
  //   log.debug("Initialized store and config");
  require("./main.js");
  if (!__IFRAME__)
    initializeAds(store, logEvent, incrementLives, showSuccessSnackbar);
  if (__DEV__) require("./fps");
}

async function fetchData() {
  try {
    await yieldWithPriority("background");
    await fetchStore();
    await fetchProfile();
    setProfileInfoToEls();
    store.saveAllToFirestore();
  } catch (error) {
    catchErrorWithStack(error);
  }
}

addEventListener("load", onLoad);
